export default "__VITE_PUBLIC_ASSET__7f1cbec2__"